module.exports = __webpack_public_path__ + "img/Rolling-1s-64px.94b0e759.gif";